import * as Blockly from "blockly";
import { zrCppGenerator } from "./generator/spheres/zrCppGenerator";


// ============================================================
// math_number
// ============================================================

zrCppGenerator.forBlock["math_number"] =
    function (block, generator) {

        const value =
            block.getFieldValue("NUM");

        return [
            value || "0",
            generator.ORDER_ATOMIC
        ];
    };


// ============================================================
// math_arithmetic
// ============================================================

zrCppGenerator.forBlock["math_arithmetic"] =
    function (block, generator) {

        const OPERATORS = {
            ADD: "+",
            MINUS: "-",
            MULTIPLY: "*",
            DIVIDE: "/",
            POWER: "^"
        };

        const operator =
            OPERATORS[
                block.getFieldValue("OP")
            ] || "+";

        const left =
            generator.valueToCode(
                block,
                "A",
                generator.ORDER_ADDITIVE
            ) || "0";

        const right =
            generator.valueToCode(
                block,
                "B",
                generator.ORDER_ADDITIVE
            ) || "0";

        return [
            left +
            " " +
            operator +
            " " +
            right,

            generator.ORDER_ADDITIVE
        ];
    };


// ============================================================
// math_single
// ============================================================

zrCppGenerator.forBlock["math_single"] =
    function (block, generator) {

        const OPERATORS = {

            ROOT:
                "sqrt",

            ABS:
                "abs",

            NEG:
                "-",

            LN:
                "log",

            LOG10:
                "log10",

            EXP:
                "exp",

            POW10:
                "pow10"
        };

        const operator =
            block.getFieldValue("OP");

        const value =
            generator.valueToCode(
                block,
                "NUM",
                generator.ORDER_ATOMIC
            ) || "0";


        if (operator === "NEG") {

            return [
                "-" + value,
                generator.ORDER_UNARY
            ];
        }


        const functionName =
            OPERATORS[operator] ||
            "abs";


        return [
            functionName +
            "(" +
            value +
            ")",

            generator.ORDER_FUNCTION_CALL
        ];
    };


// ============================================================
// math_round
// ============================================================

zrCppGenerator.forBlock["math_round"] =
    function (block, generator) {

        const value =
            generator.valueToCode(
                block,
                "NUM",
                generator.ORDER_ATOMIC
            ) || "0";

        const operator =
            block.getFieldValue("OP");


        let functionName = "round";


        if (operator === "ROUNDUP") {
            functionName = "ceil";
        }

        if (operator === "ROUNDDOWN") {
            functionName = "floor";
        }


        return [
            functionName +
            "(" +
            value +
            ")",

            generator.ORDER_FUNCTION_CALL
        ];
    };


// ============================================================
// math_modulo
// ============================================================

zrCppGenerator.forBlock["math_modulo"] =
    function (block, generator) {

        const dividend =
            generator.valueToCode(
                block,
                "DIVIDEND",
                generator.ORDER_MULTIPLICATIVE
            ) || "0";

        const divisor =
            generator.valueToCode(
                block,
                "DIVISOR",
                generator.ORDER_MULTIPLICATIVE
            ) || "1";


        return [
            dividend +
            " % " +
            divisor,

            generator.ORDER_MULTIPLICATIVE
        ];
    };


// ============================================================
// math_constrain
// ============================================================

zrCppGenerator.forBlock["math_constrain"] =
    function (block, generator) {

        const value =
            generator.valueToCode(
                block,
                "VALUE",
                generator.ORDER_ATOMIC
            ) || "0";

        const low =
            generator.valueToCode(
                block,
                "LOW",
                generator.ORDER_ATOMIC
            ) || "0";

        const high =
            generator.valueToCode(
                block,
                "HIGH",
                generator.ORDER_ATOMIC
            ) || "0";


        return [
            "constrain(" +
            value +
            ", " +
            low +
            ", " +
            high +
            ")",

            generator.ORDER_FUNCTION_CALL
        ];
    };